// extracted by mini-css-extract-plugin
export default {"button-pair-wrapper":"dialog_button-pair-wrapper__MHvXJ"};